import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import './rem.js'
import lstore from '@/plugins/lstore/index.js'
import api from '@/api.js'

Vue.use(Vant);
Vue.use(lstore)
Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
